import Vue from "vue";

import "./styles/quasar.scss";
import "quasar/dist/quasar.ie.polyfills";
import "@quasar/extras/roboto-font/roboto-font.css";
import "@quasar/extras/mdi-v5/mdi-v5.css";
import "@quasar/extras/material-icons/material-icons.css";
import "@quasar/extras/fontawesome-v5/fontawesome-v5.css";
import iconSet from "quasar/icon-set/mdi-v5";
import langPt from "quasar/lang/pt";
import { Loading, Notify, Quasar, Dialog, AddressbarColor, LoadingBar } from "quasar";



Vue.use(Quasar, {
  iconSet: iconSet,
  config: {
    notify: {
      position: "bottom-right",
      timeout: 6000,
    },
    loadingBar: {
      color: 'primary',
      size: '5px',
      position: 'bottom'
    },
    animations: ["all"],
  },
  components: {
    /* not needed if importStrategy is not 'manual' */
  },
  directives: {
    /* not needed if importStrategy is not 'manual' */
  },
  plugins: {
    Loading,
    Notify,
    Dialog,
    AddressbarColor,
    LoadingBar  
  },
  lang: langPt,
  boot: ["addressbar-color"],
});
